import {
  CheckNotes,
  InspectionCase,
  InspectionTimeCase,
  InspectionTimeCaseDto,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';

export class SprinklerSystemsDto extends InspectionCase {
  deploymentAccordingSpec?: InspectionCase;
  designedPipeType?: InspectionCase;
  maxWaterNeededAtMainStation?: InspectionWaterSupplyDataCaseDto;
  maxWaterNeededAtSource?: InspectionWaterSupplyDataCaseDto;
  sprinklerOffTimeRequirenments?: InspectionTimeCaseDto;
  requiredPoolingVolume?: InspectionWaterSupplyDataCaseDto;
  hydraulicWaterRequirementMatchWaterSupplyDesign?: InspectionCase;
}

export class SprinklerSystems extends SprinklerSystemsDto {
  constructor(
    data: SprinklerSystemsDto = { title: 'מערכות מתזים סגורות במים' }
  ) {
    super(data);
    this.deploymentAccordingSpec = new InspectionCase({
      ...data.deploymentAccordingSpec,
      title: 'פריסת המתזים / נחירים מתאימה לדרישות התקן?'
    });
    this.designedPipeType = new InspectionCase({
      ...data.designedPipeType,
      title: 'סוג הצנרת שתוכנן'
    });
    this.maxWaterNeededAtMainStation = new InspectionWaterSupplyDataCase({
      ...data.maxWaterNeededAtMainStation,
      title: 'דרישת המים המירבית הדרושה במבוא לתחנת ההפעלה הראשית'
    });
    this.maxWaterNeededAtSource = new InspectionWaterSupplyDataCase({
      ...data.maxWaterNeededAtSource,
      title: 'דרישת המים המירבית הדרושה במקור המים (חדר משאבות / רשת עירונית)'
    });
    this.sprinklerOffTimeRequirenments = new InspectionTimeCase({
      ...data.sprinklerOffTimeRequirenments,
      title: 'משך זמן כבוי נדרש בהתאם לדרישות התקן (min)'
    });
    this.requiredPoolingVolume = new InspectionWaterSupplyDataCase({
      ...data.requiredPoolingVolume,
      title: 'נפח איגום נדרש (m^3)'
    });
    this.hydraulicWaterRequirementMatchWaterSupplyDesign = new InspectionCase({
      ...data.hydraulicWaterRequirementMatchWaterSupplyDesign,
      title:
        'האם דרישת המים עפ"י החישובים ההידראולים מתאימה לנתוני מקור אספקת המים שתכנן'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.deploymentAccordingSpec.isApplicable ||
        this.deploymentAccordingSpec.isPassed) &&
        (!this.designedPipeType.isApplicable ||
          this.designedPipeType.isPassed) &&
        (!this.maxWaterNeededAtMainStation.isApplicable ||
          this.maxWaterNeededAtMainStation.isPassed) &&
        (!this.maxWaterNeededAtSource.isApplicable ||
          this.maxWaterNeededAtSource.isPassed) &&
        (!this.sprinklerOffTimeRequirenments.isApplicable ||
          this.sprinklerOffTimeRequirenments.isPassed) &&
        (!this.requiredPoolingVolume.isApplicable ||
          this.requiredPoolingVolume.isPassed) &&
        (!this.hydraulicWaterRequirementMatchWaterSupplyDesign.isApplicable ||
          this.hydraulicWaterRequirementMatchWaterSupplyDesign.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.deploymentAccordingSpec.getNotes(),
      ...this.designedPipeType.getNotes(),
      ...this.maxWaterNeededAtMainStation.getNotes(),
      ...this.maxWaterNeededAtSource.getNotes(),
      ...this.sprinklerOffTimeRequirenments.getNotes(),
      ...this.requiredPoolingVolume.getNotes(),
      ...this.hydraulicWaterRequirementMatchWaterSupplyDesign.getNotes()
    ];
  }
}
